

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <vendedor></vendedor>
</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import vendedor from '@/components/tienda/vendedor/Vendedor.vue';



export default {
    data () {
    return {
              
    }
  },
  components: {
    
    vendedor
    
  },

  methods: {

}

}
    

</script>


